<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <!-- <div class="breadcrumb-title pe-3"><span [translate]="'GREATER.STATIC_PAGE'"> </span></div> -->
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                            <!-- <li class="breadcrumb-item active" aria-current="page"><span [translate]="'GREATER.STATIC_PAGES'"> </span></li> -->
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group ms-2" role="group">
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-3 col-md-3 pb-3">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.SEARCH_NAME'"> </span></label>
                    <input type="text" id="inputState" class="form-control" placeholder="{{ 'GREATER.SEARCH_NAME' | translate }}" [(ngModel)]='searchKey' (change)="p=1;getDetail(p)">
                </div>  
                <div class="col-3 col-md-3 pb-3">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.TRANSACTION_TYPE'"> </span></label>
                    <select id="inputState" class="form-select" [(ngModel)]='searchtype' (change)="p=1;getDetail(p)">
                        <option value="" selected hidden disabled><span [translate]="'GREATER.SELECT'"> </span></option>
                        <option value="Program"><span [translate]="'GREATER.PROGRAM'"> </span></option>
                        <option value="Subscribe"><span [translate]="'GREATER.SUBSCRITIONS'"> </span></option>
                    </select>
                </div> 
                <div class="col-3 col-md-3 pb-3">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.CREATER'"> </span>/<span [translate]="'GREATER.ORGANISATION'"> </span></label>
                    <select id="inputState" class="form-select" [(ngModel)]='searchname' (change)="p=1;getDetail(p)">
                        <option value="" selected hidden disabled><span [translate]="'GREATER.SELECT'"> </span></option>
                        <option value="Individual Creator"><span [translate]="'GREATER.CREATER'"> </span></option>
                        <option value="Organisation"><span [translate]="'GREATER.ORGANISATION'"> </span></option>
                    </select>
                </div>              
                <div class="col-3 col-md-3 pb-3 pt-4">
                    <button type="button" class="btn custom-btn brand-btn2 px-4" (click)="reset()"><span [translate]="'GREATER.RESET'"> </span></button>
                </div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-title d-flex align-items-center">
                                <h5 class="mb-2" ><span [translate]="'GREATER.TRANSACTION'"> </span></h5>
                            </div>
                            <hr>
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.TRANSACTION_ID'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.TRANSACTION_U_ID'"> </span></th>

                                        <th scope="col"><span [translate]="'GREATER.AMOUNT'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.TRANSACTION_TYPE'"> </span></th>

                                                                                <th scope="col" class="d-flex"><span [translate]="'GREATER.DATE'"></span> 
                                           <span style="cursor: pointer;" class="ms-2"> <i class="bx bx-arrow-to-top" (click)="sortType='asc';p=1;getDetail(p)"></i> <i class="bx bx-arrow-to-bottom" (click)="sortType='desc';p=1;getDetail(p)"></i></span>  </th>

                                        <th scope="col"><span [translate]="'GREATER.USER'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.CREATER'"> </span>/<span [translate]="'GREATER.ORGANISATION'"> </span></th>

                                        <th scope="col"><span [translate]="'GREATER.NAME'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                        <!-- <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of dataListing  | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td>{{item.txnId}}</td>
                                        <td>{{item.txnUniqueId}}</td>
                                        <td>{{service.currency}}{{item.txnAmout}}</td>
                                        <td *ngIf="item.txnFor=='Program'">{{item.txnFor}}</td>
                                        <td *ngIf="item.txnFor!='Program'"><span [translate]="'GREATER.SUBSCRITIONS'"> </span></td>
                                        <td>{{service.convertDate(item.createdAt)}}</td>
                                        <td>{{item.users[0].name}} {{item.users[0].surname}}</td>
                                        <td>{{item.creator[0].roles.name}}</td>
                                        <td>{{item.creator[0].name}} {{item.creator[0].surname}}</td>
                                        <td>
                                            <span class="badge bg-success text-capitalize" *ngIf="item.txnStatus == 'succeeded'">{{item.txnStatus}}</span>
                                            <span class="badge bg-danger text-capitalize" *ngIf="item.txnStatus != 'succeeded'">{{item.txnStatus}}</span>
                                        </td>
                                        <!-- <td>
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-info text-center" (click)="redirect(item)">
                                                    <i class="bx bx-pencil"></i>
                                                </button>
                                                <button type="button" class="btn btn-danger text-center" (click)="redirect(item)">
                                                    <i class="bx bx-trash"></i>
                                                </button>
                                            </div>
                                        </td> -->
                                    </tr>

                                </tbody>
                            </table>  
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>
